export default "__VITE_ASSET__cc2e0172__"